module.exports = __webpack_public_path__ + "img/0Q3A8622_L_Foamcore_MockedUp.b4fc9cf7.jpg";